import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Company = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [num, setNum] = useState(0);
  const [num2, setNum2] = useState(0);
  const [num3, setNum3] = useState(0);
  const counterRef = useRef(null); // 카운터 섹션의 ref

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 철학`;

    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      if (result.redirect) {
        navigate(result.redirect);
      }
    };

    checkIP();

    const animateCounter = (target, setValue) => {
      let count = 0;
      const increment = Math.ceil(target / 100); // 100단위로 증가
      const interval = setInterval(() => {
        if (count < target) {
          count += increment;
          setValue(count > target ? target : count);
        } else {
          clearInterval(interval);
        }
      }, 15);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(20, setNum);
          animateCounter(100000, setNum2);
          animateCounter(2000, setNum3);
          observer.disconnect(); // 관찰 종료
        }
      });
    });

    // ref 값 복사
    const currentRef = counterRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef); // cleanup에서 복사된 ref 사용
      }
    };
  }, [location, navigate]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/company" className="sel">
                  아소비 철학
                </a>
              </li>
              <li>
                <a href="/history">주요 연혁</a>
              </li>
              <li>
                <a href="/location">오시는 길</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="company">
          <div className="sect company01 init">
            <div className="bg">
              <img
                src="../custom-resources/img/img_company_company01.png"
                className="pc-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_company_company01_mo.png"
                className="mo-view"
                alt=""
              />
            </div>
            <div className="height">
              <img
                src="../custom-resources/img/img_company_company01.png"
                className="pc-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_company_company01_mo.png"
                className="mo-view"
                alt=""
              />
            </div>
            <div className="wrap">
              <div className="tit">
                우리 아이들의 <span>꿀처럼 단 배움의 기쁨</span>, <br />
                아소비에서 느낄 수 있습니다.
              </div>
            </div>
          </div>
          <div className="sect company02">
            <div className="wrap">
              <div className="tit init">
                왜 우리 아이들은 <br />
                배움을 행복하게 즐기지 못하는가?
              </div>
              <div className="txt init">
                교육의 길을 걷기 시작하는 우리 아이들이 <br />왜 배움을 행복하게
                느끼지 못하는가에 대한 물음에 <br />
                아소비는 해답을 찾고자 고민하고 연구하였습니다. <br />
                아소비의 프로그램은 아이들에게 단순히 문제를 풀어내기 위한
                학습이 아닌 <br />
                배움은 꿀처럼 달며 즐거운 일이라는 것을 알게 해 줍니다. <br />
                앞으로도 아소비는 더욱 열심히 학습 방법을 연구하고 개발하여{" "}
                <br />더 많은 아이들이 참 배움의 의미를 알도록 노력하겠습니다.
              </div>
              <div className="act init">
                <a href="/history">주요 연혁 보기</a>
              </div>
            </div>
          </div>
          <div className="sect company03" ref={counterRef}>
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_company_company03_img.png"
                  alt=""
                />
              </div>
              <div className="con">
                <div className="tit init">
                  <img src="../custom-resources/img/icon_leaf2.png" alt="" />
                  아소비의 경험과 결과
                </div>
                <div className="txt">
                  <ul>
                    <li className="init">
                      <strong>
                        <p id="num" className="counter">
                          {num}
                        </p>{" "}
                        +
                      </strong>
                      <span>
                        20여 년간 한결같이 교육에 연구한 <br />
                        국내 5~9세 전문 교육기업
                      </span>
                    </li>
                    <li className="init">
                      <strong>
                        <p id="num2" className="counter">
                          {num2}
                        </p>{" "}
                        +
                      </strong>
                      <span>
                        누적 10만 명 이상의 아소비 <br />
                        회원으로 학습
                      </span>
                    </li>
                    <li className="init">
                      <strong>
                        <p id="num3" className="counter">
                          {num3}
                        </p>{" "}
                        +
                      </strong>
                      <span>
                        전국 누적 가맹점 수 2,000여 개의 아소비 <br />
                        교육원에서 학습 가능
                      </span>
                    </li>
                  </ul>
                  <p className="init">＊ 2022.2.6 기준 분석결과</p>
                </div>
              </div>
            </div>
          </div>
          <div className="sect company04">
            <div className="wrap">
              <div className="con">
                <div className="tit init">
                  스마트학습이 난무하는 요즘 <br />
                  아소비는 유기농공부를 지향하며 <br />
                  배움의 진정한 의미에 책임감을 가지고 <br />
                  노력하겠습니다.
                </div>
                <div className="txt init">
                  유기농공부를 통해 스스로 즐겁게 공부하는 힘! 학습생명력을{" "}
                  <br />
                  키워줍니다. 건강한 학습습관으로 공부 자신감이 커지고 <br />
                  아이는 자연스럽게 학습 성취감을 맛보게 됩니다.{" "}
                </div>
                <div className="act init">
                  <a href="/philosophy">아소비 이념 보기</a>
                </div>
              </div>
            </div>
          </div>
          <div className="sect company05">
            <div className="wrap">
              <div className="img init">
                <img
                  src="../custom-resources/img/img_company_company05_img.png"
                  alt=""
                />
              </div>
              <div className="tit init">
                이 땅의 모든 아이들이 즐겁게 공부하는 세상! <br />
                아소비가 만들어보겠습니다.
              </div>
              <div className="txt init">
                성인의 2배에 가까운 두뇌활동으로 지능이 가장 높게 발달하는
                시기의 <br />
                5~9세 아이들에게 단순히 문제를 풀어내기 위한 학습이 아닌 <br />
                배움의 즐거움을 알게 해 주는 아소비는 함께 실현할 교육원이
                많아졌으면 좋겠습니다.
              </div>
              <div className="act init">
                <a href="/startUp">아소비 창업 알아보기</a>
              </div>
              <div className="dow init">
                <a href="../DATA/upload/ASOBICI.zip">CI 다운로드</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Company;
